const Dico = {
  HEADER: {
    SLOGAN: {
      MAIN: 'together',
      SUB: "let's make memories",
    },
    BUTTONLINK_DISCOVER_MOVIES: 'discover movies',
  },

  NAVBAR: {
    MENU_HOME: 'Home',
    MENU_MOVIES: 'Movies',
  },

  SECTION_ABOUT: {
    TITLE_PRESENTATION_GENERAL: 'Our best new movies just for you',

    TITLE_PRESENTATION_1: 'you are going fall in love with our movies',
    PARAGRAPH_PRESENTATION_1:
      'Experience love at first sight' +
      ' with our curated collection of must-watch films' +
      'and get ready to be enchanted as you explore the magic of cinema on our site.',

    TITLE_PRESENTATION_2: 'live adventures like you never have bedore',
    PARAGRAPH_PRESENTATION_2:
      'Indulge in a world of unforgettable stories' +
      ' and breathtaking visuals at our movie paradise.',

    BUTTONLINK_LEARN_MORE: 'learn more',
    BROWSER_NOT_SUPPORT_VIDEO_LABEL:
      'Your browser does not support the video tag.',
  },

  SECTION_PRICING: {
    TITLE_PRICING: 'Pricing',
    LIMITED_PRICING_PARAGRAPH:
      'The price displayed for this best offer' +
      ' is guaranteed only until 02/03/2024',
    BUTTONLINK_JOIN_NOW: 'join now',
    DETAILS: {
      FORMULA_SOLO: {
        TITLE: 'SOLO',
        SCREEN: 'Only 1 screen',
        DEVICE: 'Only mobile device',
        DOWNLOAD: 'Download not allowed',
        SUPPORT: 'Support by email',
        PRICE: '9.99$/month',
      },

      FORMULA_FAMILY: {
        TITLE: 'FAMILY',
        SCREEN: 'Up to 5 screens',
        DEVICE: 'Mobile and tablet',
        DOWNLOAD: 'Download 3 movies/week',
        SUPPORT: 'Support by email/tel',
        PRICE: '19.99$/month',
      },

      FORMULA_GROUP: {
        TITLE: 'GROUP',
        SCREEN: 'Up to 20 screens',
        DEVICE: 'All devices',
        DOWNLOAD: 'Download not limited',
        SUPPORT: 'Support by email/sms/tel - 24/7',
        PRICE: '29.99$/month',
      },
    },
  },

  SECTION_REVIEWER: {
    TITLE_REVIEWER_HOME: 'they talk about us',
    TITLE_REVIEWER_OTHER: 'Reviewers',
    BUTTONLINK_MORE: 'more',
    NO_REVIEWER_MSG: 'No reviews for this movie',
  },

  DISCLAIMER: {
    LOADING_MSG: 'loading...',
    ERROR_GLOBAL_MSG: 'sorry, something went wrong, please try later :(',
    NOT_FOUND_MSG: 'sorry, page not found :(',
    DETAILS: {
      NO_MOVIE_TO_DISPLAY: 'sorry, no movies to display :(',
      ERROR_LOADING_VIDEO: 'sorry, error loading video...',
    },
  },

  SECTION_MOVIES_LIST: {
    BUTTONLINK_LOADMORE: 'loadmore',
    SEARCH_INPUT: {
      LABEL: 'search your movie',
      PLACE_HOLDER: 'search your movie',
    },
    TRENDING: {
      TITLE_TRENDING: 'Trending',
    },
    OTHERS: {
      POPULAR: {
        TITLE_POPULAR: 'Popular',
      },
      SIMILAR: {
        TITLE_SIMILAR: 'Similar',
      },
    },
  },

  SECTION_DETAIL_MOVIE: {
    BUTTONLINK_WATCH_TRAILER: 'watch trailer',
    PRODUCTION_COMPANIES_LABEL: 'Production companies',
    COUNTRY_LABEL: 'Country',
    POPULARITY_LABEL: 'Popularity',
    AUTHOR_LABEL: 'Author',
    UPDATED_IN_PROGRESS_LABEL: 'updated in progress',
    DATE_LABEL: 'Date',
  },

  SECTION_GENRE: {
    GENRE_LIST_TITLE: '#Genres:',
  },

  FOOTER: {
    PARAGRAPH_MADE_WITH_LOVE: 'made with love',
    LIST_FOLLOW: {
      TITLE: 'follow',
      FB: 'fb',
      INSTAGRAM: 'instagram',
      TIKTOK: 'tiktok',
    },
    LIST_GENERAL: {
      TITLE: 'general',
      ABOUT: 'about',
      CONTACT_US: 'contact us',
      FAQ: 'faq',
    },
  },
}

export default Dico
